import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/filterIconDisabled.svg'
import _imports_1 from '@/assets/filterIcon.svg'
import _imports_2 from '@/assets/cancel.svg'


const _hoisted_1 = { class: "px-5 pt-3 tasks-page-fill" }
const _hoisted_2 = { class: "flex flex-col flex-1 min-h-0" }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "items-center justify-between flex" }
const _hoisted_5 = { class: "title flex items-center w-2/4" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_8 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_9 = { class: "tasks-table-section" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_12 = { class: "popup-business flex-1 overflow-y-auto" }
const _hoisted_13 = { class: "flex flex-col h-full" }
const _hoisted_14 = { class: "flex-1 overflow-auto hide-scrollbar" }
const _hoisted_15 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_16 = { class: "formcontainer flex flex-col" }
const _hoisted_17 = { class: "upperspacing" }
const _hoisted_18 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_19 = {
  key: 0,
  class: "error-text"
}
const _hoisted_20 = { class: "row flex flex-row upperspacing w-full gap-4" }
const _hoisted_21 = { class: "w-1/2" }
const _hoisted_22 = ["min"]
const _hoisted_23 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_24 = {
  key: 0,
  class: "error-text"
}
const _hoisted_25 = { class: "w-1/2" }
const _hoisted_26 = ["min"]
const _hoisted_27 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_28 = {
  key: 0,
  class: "error-text"
}
const _hoisted_29 = { class: "" }
const _hoisted_30 = { class: "upperspacing" }
const _hoisted_31 = { class: "mt-2" }
const _hoisted_32 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_33 = {
  key: 0,
  class: "error-text"
}
const _hoisted_34 = { class: "upperspacing" }
const _hoisted_35 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_36 = {
  key: 0,
  class: "error-text"
}
const _hoisted_37 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumbs = _resolveComponent("breadCrumbs")!
  const _component_tableData = _resolveComponent("tableData")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_breadCrumbs, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h1", {
            class: _normalizeClass(_ctx.titleLength > 40? 'table-ellipsis':'')
          }, _toDisplayString(_ctx.presentTemplateObject.title), 3)
        ]),
        _createElementVNode("div", _hoisted_6, [
          ((((_ctx.presentTemplateObject.controls != null||_ctx.presentTemplateObject.controls!=undefined) && _ctx.presentTemplateObject.controls.length!=0)))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(["mr-1.5", _ctx.isAddDisabled(10301) ? 'btndisabled pointer-events-none':'btnprimary']),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.startTaskPopup() && _ctx.isAddDisabled(10301)))
              }, "Start", 2))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: _normalizeClass(["mr-1.5", _ctx.isAddDisabled(10302) ? 'btndisabled pointer-events-none':'btnprimary']),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editTemplate()))
          }, "Edit", 2),
          _createElementVNode("button", {
            class: _normalizeClass(_ctx.isAddDisabled(10302) ? 'btndisabled pointer-events-none':'btnprimary'),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClickArchiveBtn()))
          }, "Archive", 2),
          _createElementVNode("button", {
            class: _normalizeClass(["ml-1.5 flex", _ctx.controlsArray.length == 0 ? 'filterButtonDisable pointer-events-none' : 'filterButton']),
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
          }, [
            (_ctx.controlsArray.length == 0)
              ? (_openBlock(), _createElementBlock("img", _hoisted_7))
              : (_openBlock(), _createElementBlock("img", _hoisted_8)),
            _cache[16] || (_cache[16] = _createTextVNode(" Filters ", -1))
          ], 2)
        ])
      ]),
      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "mt-3" }, [
        _createElementVNode("p", { class: "text-xs" }, " This course helps you to Understand current data protection legislation and underlying principles. It also helps you to Understand what Privacy Awareness is, what PII is, PII Processing, Individual Rights, Cross Border Transfers, PII Breaches, Privacy By Design. This course helps you to understand what Information Security is, awareness on information security, different kinds of security breaches happening in daily life, physical security, email security, Knowing your responsibilities when dealing with Information Security. ")
      ], -1)),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_tableData, {
          class: "flex-1 min-h-0",
          tableRowData: _ctx.controlsArray,
          headersData: _ctx.headers,
          loadData: _ctx.dataLoading
        }, null, 8, ["tableRowData", "headersData", "loadData"]),
        (_ctx.toolTipActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.createTaskPopup)
        ? (_openBlock(), _createBlock(_component_popup, {
            key: 0,
            popUp: _ctx.createTaskPopup
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h1", {
                  class: _normalizeClass(["w-1/2", _ctx.titleLength > 40? 'table-ellipsis':''])
                }, _toDisplayString(_ctx.presentTemplateObject.title), 3),
                _createElementVNode("button", {
                  class: "float-right text-3xl",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onCloseAddPopup()))
                }, [...(_cache[17] || (_cache[17] = [
                  _createElementVNode("img", {
                    src: _imports_2,
                    class: "h-5 w-5 cursor-pointer"
                  }, null, -1)
                ]))])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _cache[18] || (_cache[18] = _createElementVNode("label", {
                            for: "number",
                            class: "controllabel"
                          }, "Title", -1)),
                          _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "number",
                            class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': _ctx.v$.templateTaskObj.mainTaskName.$error }]),
                            placeholder: "Task Name",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.templateTaskObj.mainTaskName) = $event))
                          }, null, 2), [
                            [
                              _vModelText,
                              _ctx.templateTaskObj.mainTaskName,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.templateTaskObj.mainTaskName.$error )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                (_ctx.v$.templateTaskObj.mainTaskName.required.$invalid )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _cache[20] || (_cache[20] = _createElementVNode("label", { class: "controllabel text-xs" }, "Start Date", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "date",
                              class: _normalizeClass(["mt-2", {'is-invalid': _ctx.v$.templateTaskObj.startDate.$error,'inputboxstylingForSelectAtPopup': _ctx.templateTaskObj.startDate === '','stylingForInputboxstylingForSelectAtPopup': _ctx.templateTaskObj.startDate !== '' }]),
                              onFocus: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                              min: _ctx.today,
                              onkeydown: "return false",
                              onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.checkForStartDate && _ctx.checkForStartDate(...args))),
                              placeholder: "Select Start Date",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.templateTaskObj.startDate) = $event))
                            }, null, 42, _hoisted_22), [
                              [_vModelText, _ctx.templateTaskObj.startDate]
                            ]),
                            (_ctx.v$.templateTaskObj.startDate.$error )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                  (_ctx.v$.templateTaskObj.startDate.required.$invalid )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _cache[21] || (_cache[21] = _createElementVNode("label", { class: "controllabel text-xs" }, "Due Date", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "date",
                              class: _normalizeClass(["mt-2", {'is-invalid': _ctx.v$.templateTaskObj.dueDate.$error,'inputboxstylingForSelectAtPopup': _ctx.templateTaskObj.dueDate === '','stylingForInputboxstylingForSelectAtPopup': _ctx.templateTaskObj.dueDate !== '' }]),
                              onFocus: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                              onkeydown: "return false",
                              min: _ctx.templateTaskObj.startDate||_ctx.today,
                              onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.checkForStartDate && _ctx.checkForStartDate(...args))),
                              placeholder: "Select Start Date",
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.templateTaskObj.dueDate) = $event))
                            }, null, 42, _hoisted_26), [
                              [_vModelText, _ctx.templateTaskObj.dueDate]
                            ]),
                            (_ctx.v$.templateTaskObj.dueDate.$error )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                  (_ctx.v$.templateTaskObj.dueDate.required.$invalid )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _cache[23] || (_cache[23] = _createElementVNode("label", { class: "controllabel text-xs" }, "Assigned To", -1)),
                            _createElementVNode("div", _hoisted_31, [
                              _createVNode(_component_AutoComplete, {
                                modelValue: _ctx.templateTaskObj.assignee,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.templateTaskObj.assignee) = $event)),
                                suggestions: _ctx.userOptions,
                                onComplete: _ctx.asyncFind,
                                appendTo: "self",
                                optionLabel: "label",
                                optionValue: "value",
                                placeholder: "Assigned-To",
                                class: _normalizeClass(["p-inputtext-sm systemsstyling mt-2 custom-multiselect userSelect", {
															'p-invalid': _ctx.v$.templateTaskObj.assignee.$error,
                                                            'has-options': _ctx.userOptions && _ctx.userOptions.length > 0,
                                                            'no-options': !_ctx.userOptions.length &&  _ctx.searchValue !== ''
														}])
                              }, {
                                empty: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                  _createElementVNode("span", null, "No Members Found", -1)
                                ]))]),
                                _: 1
                              }, 8, ["modelValue", "suggestions", "onComplete", "class"]),
                              (_ctx.v$.templateTaskObj.assignee.$error )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                    (_ctx.v$.templateTaskObj.assignee.required.$invalid )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _cache[24] || (_cache[24] = _createElementVNode("label", { class: "controllabel text-xs" }, "Description", -1)),
                          _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            name: "Description",
                            placeholder: "Description",
                            id: "",
                            class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': _ctx.v$.templateTaskObj.description.$error }]),
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.templateTaskObj.description) = $event))
                          }, null, 2), [
                            [
                              _vModelText,
                              _ctx.templateTaskObj.description,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.templateTaskObj.description.$error )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                (_ctx.v$.templateTaskObj.description.required.$invalid )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["mr-2", (JSON.stringify(_ctx.templateTaskObjDummy) == JSON.stringify(_ctx.templateTaskObj)) ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                        disabled: _ctx.clickOnButton,
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onCancelbtn()))
                      }, "Reset", 10, _hoisted_38),
                      _createElementVNode("button", {
                        class: _normalizeClass(["", (JSON.stringify(_ctx.templateTaskObjDummy) == JSON.stringify(_ctx.templateTaskObj)) ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                        disabled: _ctx.clickOnButton,
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.clickOnSubmitToCreateTask()))
                      }, "Save", 10, _hoisted_39)
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["popUp"]))
        : _createCommentVNode("", true)
    ])
  ]))
}